const DEFAULT_IMAGE_SELECTOR = '#print_secure_badge_qr .secure-badge-print-image';
const DEFAULT_PRINT_CLASS = 'secure-badge-printing';

const waitForImageReady = (selector, timeoutMs) =>
  new Promise((resolve) => {
    const image = document.querySelector(selector);

    if (!image) {
      resolve();
      return;
    }

    let settled = false;
    let timeoutId;

    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      image.removeEventListener('load', handleLoad);
      image.removeEventListener('error', finish);
      resolve();
    };

    const handleLoad = () => {
      if (image.decode) {
        image.decode().then(finish).catch(finish);
        return;
      }
      finish();
    };

    timeoutId = setTimeout(finish, timeoutMs);

    if (image.complete && image.naturalWidth > 0) {
      handleLoad();
      return;
    }

    image.addEventListener('load', handleLoad);
    image.addEventListener('error', finish);
  });

export const printSecureBadge = ({
  imageSelector = DEFAULT_IMAGE_SELECTOR,
  printBodyClass = DEFAULT_PRINT_CLASS,
  imageTimeoutMs = 5000,
  cleanupFallbackMs = 60000,
  onAfterPrint,
} = {}) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (onAfterPrint) onAfterPrint();
    return Promise.resolve();
  }

  document.body.classList.add(printBodyClass);

  return waitForImageReady(imageSelector, imageTimeoutMs).then(() => {
    let cleanedUp = false;
    let fallbackId;

    const cleanup = () => {
      if (cleanedUp) return;
      cleanedUp = true;
      clearTimeout(fallbackId);
      window.removeEventListener('afterprint', cleanup);
      document.body.classList.remove(printBodyClass);
      if (onAfterPrint) onAfterPrint();
    };

    window.addEventListener('afterprint', cleanup);
    fallbackId = setTimeout(cleanup, cleanupFallbackMs);

    try {
      window.print();
    } catch (error) {
      cleanup();
      throw error;
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/secureBadgePrint.js